export default __webpack_public_path__ + "static/media/Hexagon.037551a7.svg";